"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.settings.general': 'Ogólne',
    'route.settings.styles': 'Style',
    'route.settings.access': 'Dostępy',
    'route.settings.accessEdit': 'Edytuj dostęp',
    'route.settings.accessAdd': 'Dodaj dostęp',
    'route.settings.comms': 'Komunikacja',
    'route.settings.socialMediaPlan': 'Marki i Zespół',
    'route.settings.whatsapp.manage': 'Zarządzaj numerem WhatsApp',
    'route.settings.whatsappSettings': 'Numery WhatsApp',
    'route.settings.whatsappSettings.create': 'Dodaj numer',
    'route.settings.whatsappSettings.edit': 'Edytuj numer',
};
